import { coerceValueRef } from "../authContext";
import type {
  AuthDescriptor,
  QueryEntryRef,
  QueryEntryRefInput,
} from "../authDescriptor";

function coerceQuery(q: QueryEntryRefInput): QueryEntryRef {
  return { name: q.name, value: coerceValueRef(q.value) };
}

export function queryAuth(params: QueryEntryRefInput[]): AuthDescriptor {
  return { type: "query", params: params.map(coerceQuery) };
}
